import { retireServiceWorkers } from "~/utils/service-worker-retirement"

export default defineNuxtPlugin(async (nuxtApp) => {
	if (!("serviceWorker" in navigator) && !("caches" in window)) return

	try {
		const retired = await retireServiceWorkers({
			serviceWorker: navigator.serviceWorker,
			cacheStorage: window.caches,
		})
		if (retired.registrations || retired.caches) {
			try {
				;(nuxtApp.$posthog as { capture?: (event: string, properties?: Record<string, unknown>) => void } | undefined)
					?.capture?.("offline_worker_retired", retired)
			} catch (_) {}
		}
	} catch (error) {
		console.warn("Unable to finish service worker cleanup", error)
	}
})
